import CommentInput from "./index.vue"

export default CommentInput
